<template>
    <ul class="pagination">
        <li class="page-item" :class="{ disabled: pageNum === 0 }">
            <a class="page-link" href="#" v-bind="{ tabindex: pageNum === 0 ? '-1' : null, 'aria-disabled': pageNum === 0 ? 'true' : null }" @click="(evt) => selectPage(0, evt)">
                <alzata-icon :icon="'far/chevron-double-left'" />
            </a>
        </li>
        <li class="page-item" :class="{ disabled: pageNum === 0 }">
            <a class="page-link" href="#" v-bind="{ tabindex: pageNum === 0 ? '-1' : null, 'aria-disabled': pageNum === 0 ? 'true' : null }" @click="(evt) => selectPage(pageNum - 1, evt)">
                <alzata-icon :icon="'far/chevron-left'" />
            </a>
        </li>
        <li class="page-item" v-for="page in pages" :key="page.id" :class="{ active: page.id == pageNum, disabled: page.isSep ? 'true' : null }" v-bind="{ 'aria-current': page.id === pageNum ? 'page' : null }">
            <a class="page-link" href="#" v-bind="page.isSep ? { tabIndex: '-1', 'aria-disabled': true } : {}" @click="(evt) => selectPage(page.id, evt)">
                <alzata-icon v-if="page.isSep" :icon="'far/ellipsis-h'" />
                {{page.isSep ? null : page.label}}
            </a>
        </li>
        <li class="page-item" :class="{ disabled: pageNum === numPages - 1 }">
            <a class="page-link" href="#" v-bind="{ tabindex: pageNum === (numPages - 1) ? '-1' : null, 'aria-disabled': pageNum === (numPages - 1) ? 'true' : null }" @click="(evt) => selectPage(pageNum + 1, evt)">
                <alzata-icon :icon="'far/chevron-right'" />
            </a>
        </li>
        <li class="page-item" :class="{ disabled: pageNum === numPages - 1 }">
            <a class="page-link" href="#" v-bind="{ tabindex: pageNum === (numPages - 1) ? '-1' : null, 'aria-disabled': pageNum === (numPages - 1) ? 'true' : null }" @click="(evt) => selectPage(numPages - 1, evt)">
                <alzata-icon :icon="'far/chevron-double-right'" />
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'AlzataPaginator',
    props: {
        numPages: Number,
        pageNum: Number,
        context: {
            type: Number,
            default: 3,
        },
    },
    methods: {
        selectPage(x, evt) {
            evt.preventDefault();
            this.$emit('selectPage', x);
        },
    },
    computed: {
        pages() {
            var pages = [];
            var needSep = false;
            for (var i = 0; i < this.numPages; ++i) {
                if (i < this.context || Math.abs(this.pageNum - i) <= this.context || this.numPages - i - 1 < this.context) {
                    pages.push({
                        id: i,
                        label: (i + 1).toString(),
                    });
                    needSep = true;
                }
                else if (needSep) {
                    pages.push({
                        id: i,
                        label: '...',
                        isSep: true,
                    });
                    needSep = false;
                }
            }
            return pages;
        },
    },
};
</script>